import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { MetaDataService } from '../metadata.service';
import { NGXLogger } from 'ngx-logger';
import { Subject, takeUntil } from 'rxjs';
import { AsyncPipe } from '@angular/common';
import { TeaItemSummaryComponent } from '../tea-item-summary/tea-item-summary.component';
import { MarkdownPipe } from '../markdown.pipe';
import { TeaByRegionResolverData } from './tea-by-region.resolver';

@Component({
    selector: 'tea-shop-fe-tea-region',
    templateUrl: './tea-by-region.component.html',
    styleUrls: ['./tea-by-region.component.css'],
    imports: [TeaItemSummaryComponent, AsyncPipe, MarkdownPipe]
})
export class TeaByRegionComponent implements OnInit, OnDestroy {
  private route = inject(ActivatedRoute);
  private metaDataService = inject(MetaDataService);
  private logger = inject(NGXLogger);

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  teaRegion: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  teas: any[] = [];
  errors: string[] = [];
  private destroy$ = new Subject<void>();

  ngOnInit() {
    // Subscribe to route data changes instead of using snapshot
    this.route.data.pipe(
      takeUntil(this.destroy$)
    ).subscribe((data) => {
      this.updateComponentData(data);
    });
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  private updateComponentData(data: Data) {
    // Reset component state
    this.teaRegion = null;
    this.teas = [];
    this.errors = [];
    
    // Get the resolved data from the route
    const regionData: TeaByRegionResolverData = data['regionData'];
    
    if (regionData) {
      this.teaRegion = regionData.teaRegion;
      this.teas = regionData.teas;
      this.errors = regionData.errors;
      
      // Update metadata if tea region is available
      if (this.teaRegion) {
        this.metaDataService.updateMetadata({
          title: `Teas from ${this.teaRegion.name} - Sencha Tea`,
          image: `/assets/tea-type-lady/green-tea-lady.png`,
        });
      }
    } else {
      this.errors.push('Failed to load tea region data.');
    }
  }
}
